import { j as n } from "./jsx-runtime-3tyXYecC.mjs";
import * as l from "react";
import { useContext as c, cloneElement as p } from "react";
import { C as f } from "./menu-item-D2hpbuev.mjs";
import { f as r } from "./index-LyFokDcn.mjs";
import { m as u } from "./tss-DN0acMKN.mjs";
import { L as g } from "./ListItemAvatar-DT4cgzXB.mjs";
import { g as x, c as h } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { m as y } from "./memoTheme-BzXKG_-k.mjs";
import { g as S } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { L as v } from "./ListItemText-C34sqqNp.mjs";
import { s as C, u as L, c as w } from "./DefaultPropsProvider-CFfEbxdP.mjs";
function R(t) {
  return x("MuiListItemIcon", t);
}
S("MuiListItemIcon", ["root", "alignItemsFlexStart"]);
const j = (t) => {
  const {
    alignItems: s,
    classes: o
  } = t;
  return w({
    root: ["root", s === "flex-start" && "alignItemsFlexStart"]
  }, R, o);
}, k = C("div", {
  name: "MuiListItemIcon",
  slot: "Root",
  overridesResolver: (t, s) => {
    const {
      ownerState: o
    } = t;
    return [s.root, o.alignItems === "flex-start" && s.alignItemsFlexStart];
  }
})(y(({
  theme: t
}) => ({
  minWidth: 56,
  color: (t.vars || t).palette.action.active,
  flexShrink: 0,
  display: "inline-flex",
  variants: [{
    props: {
      alignItems: "flex-start"
    },
    style: {
      marginTop: 8
    }
  }]
}))), F = /* @__PURE__ */ l.forwardRef(function(s, o) {
  const e = L({
    props: s,
    name: "MuiListItemIcon"
  }), {
    className: i,
    ...a
  } = e, d = l.useContext(v), m = {
    ...e,
    alignItems: d.alignItems
  }, I = j(m);
  return /* @__PURE__ */ n.jsx(k, {
    className: h(I.root, i),
    ownerState: m,
    ref: o,
    ...a
  });
}), b = u()(({ palette: t }) => ({
  root: {
    marginBottom: r.ifFeature("encore", 0, 5),
    marginRight: 10,
    marginTop: r.ifFeature("encore", 0, 5),
    minWidth: 32
  },
  children: {
    width: 32,
    height: 32
  },
  fallback: {
    fill: t.common.white,
    backgroundColor: t.primary.main
  },
  muted: {
    opacity: 0.5
  }
})), q = (t) => {
  const { active: s, muted: o } = c(f), { classes: e, cx: i } = b(), { children: a } = t;
  return /* @__PURE__ */ n.jsx(g, { classes: { root: i(e.root, { [e.muted]: o }) }, ...t, children: p(a, {
    classes: { fallback: s ? e.fallback : "" },
    className: e.children
  }) });
}, z = u()(({ palette: t }) => ({
  root: {
    alignItems: "center",
    fill: t.primary.main,
    display: "flex",
    justifyContent: "center",
    marginRight: 8,
    minWidth: "unset"
  },
  // @startCleanup encore
  active: {
    fill: r.ifFeature("encore", void 0, t.primary.contrastText)
  },
  // @endCleanup encore
  smallSize: {
    height: 14,
    width: 14
  },
  mediumSize: {
    height: 16,
    width: 16
  }
})), G = (t) => {
  const { active: s, disabled: o, size: e } = c(f), { classes: i, cx: a } = z();
  return /* @__PURE__ */ n.jsx(
    F,
    {
      "aria-hidden": !0,
      className: a(i.root, {
        [i.active]: s && !o,
        [i.smallSize]: e === "small" || e === "teenie",
        [i.mediumSize]: !(e === "small" || e === "medium")
      }),
      ...t
    }
  );
};
export {
  q as A,
  G as I
};
//# sourceMappingURL=icon-D1EZsrMS.mjs.map
